import { mapGetters } from 'vuex'
import { registerInverval } from '@/utilities/global.interval'
import DonutholeChartLabelPlugin from '@/components/chart/plugins/donuthole-chart-label.plugin'
import { DASHBOARD_POLLING_INTERVAL } from '@/constants/polling-interval.constants'
import {
  TRAIL_DETAILS_LATERALMOVEMENT_REQ,
  TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS,
  TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR
} from '@/store/modules/trails/trailsinfo.type'

export default {
  methods: {
    sortTrailList (sortOrder) {
      // default to riskscore for sort
      let prop = 'riskScore'

      // if sort property changes to datetime for latest or earliest, use lastIocSeenTime
      if (sortOrder.includes('datetime')) {
        prop = 'lastIocSeenTime'
      }

      this.selectedPostureInfoList.sort((a, b) => {
        if (sortOrder.includes('desc')) {
          return b[prop] - a[prop]
        }
        return a[prop] - b[prop]
      })
    },
    mapFoundTrailLinks (trails, movements) {
      return _.filter(movements, latMov => {
        return _.some(trails, { trailIdHash: latMov['globalTrailIdHash'] })
      })
    },
    updateTrailAndAgent (ignoreScore = false) {
      this.trailsIntervalId = setTimeout(() => {
        this.updateAgentInfo(ignoreScore)
        this.updateTrailInfo()

        // communicate to parent to update summary details
        this.$parent.$parent.$emit('updateDashboardView')
      }, DASHBOARD_POLLING_INTERVAL)

      registerInverval(this.trailsIntervalId)
    },
    gotoDetails (trail) {
      this.$router.push({
        name: 'attack-track-details',
        params: { trailId: trail.trailIdHash }
      })
    },
    highlightNode (row, event) {
      // if we are still retrieving last request, reject new request
      if (this.trailDetailMovementsStatus === 'inprogress') {
        return false
      }

      // deselect other rows
      this.unselectOutsideTrails(row)

      if (!row.selected) {
        this.hideHighlightNode(row, event)
        return false
      }

      // on hover, show links
      this.$store.dispatch(TRAIL_DETAILS_LATERALMOVEMENT_REQ, row.trailIdHash).then(movements => {
        _.assignIn(row, {
          hostList: movements.hostList
        })

        // remove all lateral movements not pertaining to attack trails
        let latMoveLinks = this.getNetworkLinks(movements.lateralMovementEdges, this.networkHosts.nodes)

        if (this.trailDetailMovementsStatus === 'failed') {
          return false
        }

        this.$set(this.networkHosts, 'links', latMoveLinks)
        this.$refs.agentNetwork.unfadeAgents(movements.hostList)
        this.$refs.agentNetwork.hideTooltip(event)
        this.$store.dispatch(TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS)
      })
    },
    hideHighlightNode (row, event) {
      // if user leaves row before response is fetch, fail out
      this.$store.dispatch(TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR)
      this.$set(this.networkHosts, 'links', [])
      this.$refs.agentNetwork.displayByCriticality('')
      this.$refs.agentNetwork.hideTooltip(event)
      this.$refs.agentNetwork.displayAllAgents()
    }
  },
  computed: {
    ...mapGetters(['trailDetailMovementsStatus']),
    donutLabelPlugin () {
      return DonutholeChartLabelPlugin
    },
    donutOptions () {
      return {
        cutoutPercentage: 80,
        rotation: 0.8 * Math.PI,
        circumference: 1.4 * Math.PI,
        plugins: {
          'donuthole-chart-label-plugin': {
            style: {
              circleFillColor: 'white',
              textfillColor: '#2e3344'
            }
          }
        }
      }
    },
    lineChartOptions () {
      return {
        layout: {
          padding: {
            left: 0,
            right: 0
          }
        },
        tooltips: {
          enabled: false
        },
        elements: {
          point: {
            pointStyle: 'line'
          },
          line: {
            fill: true,
            backgroundColor: 'rgb(242, 248, 255)',
            borderColor: 'rgb(0, 112, 249)'
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/trailInfoMixin.js